import React from 'react';

export function LiveTime({ isVerticalMode, isBaseTimeFormat, isRTL, time, styles }) {
  return (
    <div
      style={{
        ...styles.position,
        position: 'absolute',
        zIndex: 10,
        width: '2px',
        backgroundColor: '#f24c4c',
        pointerEvents: 'none',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: '#f24c4c',
          color: '#fff',
          padding: '4px 8px',
          fontSize: '11px',
          fontWeight: 600,
          borderRadius: '4px',
          whiteSpace: 'nowrap',
        }}
      >
        {time}
      </div>
    </div>
  );
}

